// Where the person just came from, so a Back button can really go back.
//
// A page's Back button that pushes its parent adds a new entry, so the
// browser's Back then returns to the page they just left and the two bounce
// forever. A Back that goes back when the parent really is the page before
// (and swaps itself for the parent otherwise) never builds that loop.
let last = null
let before = null
let action = 'POP'

/** Called once with the router's history. */
export const installNavTrail = (history) => {
  last = history.location ? history.location.pathname : null
  history.listen((location, act) => {
    before = last
    last = location.pathname
    action = act
  })
}

/** True when this page was opened (pushed) from `parent`. */
export const openedFrom = (parent) => action === 'PUSH' && before === parent

/**
 * Up to `parent`: back when that's the page before, otherwise this page is
 * swapped for it. Either way the history doesn't grow.
 */
export const backToParent = (history, parent) => {
  if (openedFrom(parent) && history.length > 1) history.goBack()
  else history.replace(parent)
}
